import { render, staticRenderFns } from "./SelectorPorLista.vue?vue&type=template&id=3f2494bf&"
import script from "./SelectorPorLista.vue?vue&type=script&lang=ts&"
export * from "./SelectorPorLista.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports